import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { TourContext, type RegisteredTour } from './useTourContext';

/**
 * Provides a single `startTour` handle so a page's `useTour` can register its
 * start callback and a shared app-shell element (e.g. the header help button)
 * can trigger it. Wrap the authenticated layout with this provider.
 */
export function TourProvider({ children }: { children: ReactNode }) {
  const [tours, setTours] = useState<RegisteredTour[]>([]);

  const registerTour = useCallback((tour: RegisteredTour) => {
    setTours((prev) => [...prev.filter((t) => t.id !== tour.id), tour]);
    return () => setTours((prev) => prev.filter((t) => t.id !== tour.id));
  }, []);

  const value = useMemo(() => ({ tours, registerTour }), [tours, registerTour]);

  return <TourContext.Provider value={value}>{children}</TourContext.Provider>;
}
